module.exports = __webpack_public_path__ + "static/media/message.e6ee6b9e.wav";